
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"11.996","height":"14.567"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon material-file-download","d":"M12 5.141H8.569V0H3.427v5.141H0l6 6zM0 12.853v1.714h12v-1.714z"}})])
          )
        }
      }
    